import NFT from '../images/nft.gif';
import Logo from '../images/logo.png'
import styled from "styled-components";
import { useWallet } from "@solana/wallet-adapter-react";
import { WalletDialogButton } from "@solana/wallet-adapter-material-ui";
import Minter from "../Minter";
import * as anchor from "@project-serum/anchor";
const candyMachineId = process.env.REACT_APP_CANDY_MACHINE_ID
  ? new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID)
  : undefined;

// const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;
const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST;
const connection = new anchor.web3.Connection(rpcHost);

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE, 10);

const txTimeout = 30000; 

const Navbar = () => {
    
    const wallet = useWallet();
  return (
    <>
    <div className="navigation">
       <nav className="navbar navbar-expand-md">
        <div className='leftitem navbar-brand' id="logo" >
           <img src={Logo} alt="Logo" />
        </div>
        <button className="navbar-toggler " type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
          <span className="navbar-toggler-icon btncollapse" ></span>
        </button>
        <div className="collapse navbar-collapse" id="collapsibleNavbar">
          <ul className="navbar-nav" style={{ width: '100%'}}>
            <li className="nav-item navtext1">
                  <h4 className='navtext' id="navtext"> WELLCOME&nbsp;&nbsp; TO&nbsp;&nbsp; <b className='companytext'> SOL ROBO</b></h4>
            </li>    
          </ul>
          <div className="form-inline my-2 my-lg-0 centeritem">
          {!wallet.connected ?( <ConnectButton className="connectBtn">Connect </ConnectButton>):(<ConnectButton className="connectBtn">Connected </ConnectButton>)}
          {/* <button className='walletbtn' id="sal">
                  CONNECT WALLET 
          </button> */}
          </div>
        </div>  
      </nav>
    </div>
    <div className="container-fluid">
        <div className='row'>
            <div className='col-md-4'>
            </div>
            <div className='col-md-4'>
            <img src={NFT} className='nft-image' alt='unable to load'  />
            </div>
            <div className='col-md-4'>
            </div>
        </div>
      <div className="main"> 
            <h4 className='textheader companytext'>Total Supply :   1222</h4>
            <h3 className='textheader' style={{ marginTop: "0px" }}><b className='companytext'>Current Price&nbsp;&nbsp;:  </b> &nbsp;&nbsp;0.3 SOL  </h3> 
            <div className='myProgress'>
                <div className='myBar'></div>
            </div>
                     <Minter
                          candyMachineId={candyMachineId}
                          connection={connection}
                          startDate={startDateSeed}
                          txTimeout={txTimeout}
                          rpcHost={rpcHost}
                        />
            {/* <button className='mintbtn'> <b> MINT</b></button> */}
      </div>
        <div className='container'>
            <div className='row'>
                <div className='col-md-6 '>
                    <div className='detail__section'>
                        <div className='card-body detail__card'>
                            <div className='row'>
                                <div className='col-md-12'>                     
                                    <h5 className='detailstext'> <b>MINTING &nbsp; INFO:</b></h5>
                                    <hr style={{ width:"60%", float: "left"}} /> <br/>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <table className='table table-borderdless'>
                                        <tr className='tr'>
                                            <td><p className='cardtext'>Mint Price</p></td>
                                            <td><p className='cardtext'>0.99 SOL</p></td>
                                        </tr>
                                        <tr className='tr'>
                                            <td><p className='cardtext'>Sale Time</p></td>
                                            <td><p className='cardtext'>TBA</p></td>
                                        </tr>
                                        <tr>
                                            <td><p className='cardtext'>Whitelist</p></td>
                                            <td><p className='cardtext'>Gurranted</p></td>
                                        </tr>
                                        <tr>
                                            <td><p className='cardtext'>Public Sale</p></td>
                                            <td><p className='cardtext'>FCFS</p></td>
                                        </tr>
                                        <tr>
                                            <td><p className='cardtext'>Accepted Currency</p></td>
                                            <td><p className='cardtext'>SOLANA</p></td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='col-md-6'>
                <div className='detail__section'>
                        <div className='card-body detail__card'>
                            
                        <div className='row'>
                                <div className='col-md-12'>                     
                                    <h5 className='detailstext'> <b>PROJECT &nbsp; INFO:</b></h5>
                                    <hr style={{ width:"60%", float: "left"}} /> <br/>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='carditem'>
                                        <h3 className='cardtext'>About SolRobo:-</h3>
                                        <p className='cardtext'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SolRobo are 1222 Unique Generated NFT Based On Solana Blockchain.
                                        SolRobo are equipped with special feature that allow it to record and upload data to unknown source</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>      
          <div className='footer'>
          </div>
    </div>
    </>
  );
}

export default Navbar;

const ConnectButton = styled(WalletDialogButton)`
float: right !important;
position: relative !important;
background-color: #FEA500 !important;
height: 56px !important;
width: 130% !important;
margin-top: 10px !important;
right: 40%;
margin-bottom: 10px !important;
font-family: 'demobold' !important;
color: #fff !important;
padding-left: 20px !important;
cursor: pointer !important; 
border: none !important;
border-radius: 10px !important;
padding-right: 20px !important;
font-size: 16px !important;
  &:hover {
    transform: scale(1.08);
  }
`
// const WalletButton = styled.button`
//   cursor: pointer;
//   max-width: 200px;
//   font-size: 14px;
//   font-family: "TTNormsBold";
//   color: #fff;
//   border-radius: 8px;
//   padding: 8px 12px;
//   display: flex;
//   align-items: center;
//   gap: 12px;
//   transition: all ease-in-out .5s;
//   background: linear-gradient(94.35deg, rgba(216, 88, 188, 0.5) -3.59%, rgba(60, 0, 255, 0.5) 102.16%);
//   border: none;

//   &:hover {
//     transform: scale(1.08);
//   }
// `